var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 667,
    height: 667,
    viewBox: "0 0 667 667",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1424_34322",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 667,
    height: 667
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.10352e-05H667V667H0V6.10352e-05Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1424_34322)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M603.635 574.432C603.635 568.424 482.692 563.554 333.5 563.554C184.308 563.554 63.3652 568.424 63.3652 574.432C63.3652 580.442 184.308 585.312 333.5 585.312C482.692 585.312 603.635 580.442 603.635 574.432Z",
    fill: "#E2DDDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.88 423.396C306.703 423.396 308.181 421.92 308.181 420.095V384.364C308.181 373.808 316.767 365.222 327.323 365.222H397.734C399.558 365.222 401.036 363.743 401.036 361.92C401.036 360.097 399.558 358.619 397.734 358.619H327.323C313.128 358.619 301.578 370.169 301.578 384.364V420.095C301.578 421.92 303.056 423.396 304.88 423.396Z",
    fill: "#E5EDF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.935 428.828H460.984L465.936 396.583L466.476 393.058L473.118 349.761L473.66 346.235L475.456 334.522L488.157 302.937L489.572 299.425L506.987 256.127L508.414 252.601L519.084 226.073H427.035C423.165 225.334 418.36 228.054 415.573 232.941C411.863 239.424 408.364 245.986 405.076 252.601C404.494 253.777 403.914 254.952 403.359 256.127C396.44 270.361 390.485 284.847 385.546 299.425C385.138 300.6 384.754 301.762 384.371 302.937C379.631 317.343 375.88 331.829 373.133 346.235C372.909 347.41 372.697 348.585 372.486 349.761C369.872 364.337 368.3 378.824 367.812 393.058C367.773 394.232 367.733 395.407 367.72 396.583C367.469 407.504 367.879 418.279 368.935 428.828Z",
    fill: "#684124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.359 256.127H506.988L508.415 252.601H405.076C404.496 253.776 403.914 254.952 403.359 256.127Z",
    fill: "#4B2B14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.371 302.936H488.158L489.57 299.423H385.546C385.137 300.598 384.754 301.76 384.371 302.936Z",
    fill: "#4B2B14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.486 349.76H473.118L473.66 346.234H373.133C372.909 347.409 372.697 348.585 372.486 349.76Z",
    fill: "#4B2B14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.721 396.582H465.936L466.477 393.056H367.813C367.774 394.232 367.734 395.407 367.721 396.582Z",
    fill: "#4B2B14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.981 428.83C467.277 425.918 473.571 423.007 479.866 420.095C474.103 362.981 489.519 298.592 522.586 240.712C525.677 235.301 525.07 229.225 521.274 226.924L521.13 226.837C517.07 224.376 510.915 227.147 507.609 232.934C471.514 296.145 454.686 366.458 460.981 428.83Z",
    fill: "#4B2B14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.232 420.096H373.913C382.18 420.096 388.879 426.796 388.879 435.063C388.879 443.327 382.18 450.027 373.913 450.027H298.232C289.967 450.027 283.268 443.327 283.268 435.063C283.268 426.796 289.967 420.096 298.232 420.096Z",
    fill: "#7A4D2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.914 420.096H481.03C489.296 420.096 495.996 426.796 495.996 435.063C495.996 443.327 489.296 450.027 481.03 450.027H373.914C365.65 450.027 358.949 443.327 358.949 435.063C358.949 426.796 365.65 420.096 373.914 420.096Z",
    fill: "#543016"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.137 562.594C439.137 556.943 443.719 552.361 449.37 552.361C455.021 552.361 459.603 556.943 459.603 562.594C459.603 568.246 455.021 572.828 449.37 572.828C443.719 572.828 439.137 568.246 439.137 562.594Z",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.369 562.594C444.369 559.834 446.608 557.595 449.369 557.595C452.129 557.595 454.369 559.834 454.369 562.594C454.369 565.355 452.129 567.594 449.369 567.594C446.608 567.594 444.369 565.355 444.369 562.594Z",
    fill: "#979598"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.535 562.594C379.535 556.943 384.117 552.361 389.768 552.361C395.42 552.361 400.003 556.943 400.003 562.594C400.003 568.246 395.42 572.828 389.768 572.828C384.117 572.828 379.535 568.246 379.535 562.594Z",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.77 562.594C384.77 559.834 387.008 557.595 389.768 557.595C392.529 557.595 394.768 559.834 394.768 562.594C394.768 565.355 392.529 567.594 389.768 567.594C387.008 567.594 384.77 565.355 384.77 562.594Z",
    fill: "#979598"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.934 562.594C319.934 556.943 324.516 552.361 330.167 552.361C335.819 552.361 340.4 556.943 340.4 562.594C340.4 568.246 335.819 572.828 330.167 572.828C324.516 572.828 319.934 568.246 319.934 562.594Z",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.168 562.594C325.168 559.834 327.406 557.595 330.168 557.595C332.928 557.595 335.168 559.834 335.168 562.594C335.168 565.355 332.928 567.594 330.168 567.594C327.406 567.594 325.168 565.355 325.168 562.594Z",
    fill: "#979598"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.334 458.83H438.201C443.064 458.83 447.004 454.888 447.004 450.026H332.531C332.531 454.888 336.472 458.83 341.334 458.83Z",
    fill: "#707477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.018 549.941H409.517V536.296H370.018V549.941Z",
    fill: "#979598"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.369 536.295H400.168V472.472H379.369V536.295Z",
    fill: "#E6E8E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.504 528.391H402.759V458.829H377.504V528.391Z",
    fill: "#979598"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.482 557.596H463.782C465.896 557.596 467.61 555.882 467.61 553.768C467.61 551.654 465.896 549.941 463.782 549.941H316.482C314.368 549.941 312.654 551.654 312.654 553.768C312.654 555.882 314.368 557.596 316.482 557.596Z",
    fill: "#707477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.927 206.983C331.079 214.048 327.269 224.56 328.767 235.013L337.986 299.362L304.303 342.623L319.765 350.344L357.297 298.933L338.927 206.983Z",
    fill: "#6B66AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.666 192.975C362.666 192.975 384.789 182.526 416.409 188.873L408.356 203.203L367.224 212.814L362.666 192.975Z",
    fill: "#6B66AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.998 198.645C359.998 198.645 380.342 184.971 414.025 192.975L374.839 258.008L359.998 198.645Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.005 242.334L362.666 192.976L338.928 206.983L342.99 313.369L334.576 365.284C334.576 365.284 337.502 385.428 368.927 368.241L374.005 242.334Z",
    fill: "#7F7ACC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.926 368.239L374.004 242.332L380.118 220.325L416.408 188.872L442.013 203.747C448.159 207.317 452.638 213.177 454.471 220.044L472.694 334.186L442.27 345.071L449.607 377.344C449.607 377.344 424.152 393.074 415.536 394.408C406.919 395.742 368.926 368.239 368.926 368.239Z",
    fill: "#7F7ACC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.004 242.333L368.926 368.24",
    stroke: "#FFEDC9",
    strokeWidth: 0.333333,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.502 329.014C365.022 306.156 386.73 280.285 404.985 252.17",
    stroke: "#DFDEFF",
    strokeWidth: 0.333333,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.541 336.051C371.09 321.518 383.69 306.92 393.973 290.705",
    stroke: "#DFDEFF",
    strokeWidth: 0.333333,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.258 206.982C437.258 206.982 422.14 215.876 423.029 227.436C423.918 238.998 439.482 315.454 439.482 315.454L393.236 334.575L397.438 358.91L443.039 345.073",
    stroke: "#FFEDC9",
    strokeWidth: 0.333333,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.85 330.187L410.138 355.057",
    stroke: "#FFEDC9",
    strokeWidth: 0.333333,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.282 340.616L374.584 344.757C372.663 345.052 371.672 346.035 371.335 347.441L368.502 359.292C368.502 359.292 373.364 363.186 376.022 353.053C376.022 353.053 389.807 361.448 396.206 351.762L394.282 340.616Z",
    fill: "#EE8D6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.409 188.873L426.408 194.236L400.867 229.66L380.119 220.326L416.409 188.873Z",
    fill: "#8A85DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.118 220.325L389.753 224.659L374.004 242.332L380.118 220.325Z",
    fill: "#6B66AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.005 242.332L368.481 218.287L359.998 225.991L374.005 242.332Z",
    fill: "#6B66AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.667 192.975L368.927 220.224L356.664 227.992L351.836 198.595L362.667 192.975Z",
    fill: "#8A85DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.262 261.949L423.063 260.547L423.699 275.781C423.699 275.781 417.643 283.756 415.314 284.227C411.148 285.067 404.511 276.864 404.511 276.864L404.262 261.949Z",
    fill: "#8A85DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.184 265.928L423.236 264.686",
    stroke: "#FFEDC9",
    strokeWidth: 0.333333,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.044 308.7L439.482 315.454L450.376 319.705",
    stroke: "#FFEDC9",
    strokeWidth: 0.333333,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.137 377.344L429.479 400.791C424.634 413.912 412.127 422.626 398.14 422.626L292.423 419.128L211.28 505.262L194.582 492.625L270.025 376.471C277.865 364.162 292.191 357.588 306.635 359.673L438.137 377.344Z",
    fill: "#ABC5D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.576 498.053L300.882 384.745",
    stroke: "#D1F0FF",
    strokeWidth: 0.333333,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.98 380.505L380.067 397.382C393.866 401.768 408.621 394.219 413.137 380.464L415.247 374.037",
    stroke: "#D1F0FF",
    strokeWidth: 0.333333,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.438 492.124L191.05 529.971L193.842 526.882L213.449 505.218L194.561 490.044C194.561 490.044 181.928 503.859 167.61 490.728C156.939 480.94 149.168 485.056 145.279 488.719C143.413 490.476 142.438 492.124 142.438 492.124Z",
    fill: "#3B1C05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.84 501.515L187.158 523.436",
    stroke: "#94460D",
    strokeWidth: 0.333333,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.511 514.992C195.511 514.992 184.93 501.763 175.402 514.657",
    stroke: "#94460D",
    strokeWidth: 0.333333,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.438 492.124L191.05 529.971L193.842 526.882L145.279 488.719C143.413 490.476 142.438 492.124 142.438 492.124Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.635 362.986L270.606 350.341L260.094 286.766C259.58 283.665 261.589 281.455 264.579 281.83L354.781 293.118C357.771 293.493 360.609 296.309 361.123 299.409L371.635 362.986Z",
    fill: "#3F404A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.927 368.24L270.605 350.343L260.093 286.768C259.581 283.667 261.589 281.457 264.578 281.83L350.956 292.641C353.947 293.015 356.784 295.832 357.298 298.932L368.927 368.24Z",
    fill: "#4E505D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.242 323.872C314.749 327.822 311.146 330.624 307.196 330.129C303.246 329.635 300.446 326.032 300.939 322.082C301.433 318.132 305.036 315.332 308.986 315.826C312.936 316.321 315.737 319.922 315.242 323.872Z",
    fill: "#5E6170"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.562 360.059L415.249 374.037C416.773 374.228 418.165 373.146 418.357 371.62C418.546 370.093 417.466 368.702 415.94 368.513L304.254 354.534C302.728 354.344 301.337 355.425 301.145 356.951C300.954 358.476 302.036 359.867 303.562 360.059Z",
    fill: "#3F404A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.965 362.509L270.605 350.343L270.856 352.515C271.092 354.571 272.704 356.198 274.757 356.456L368.927 368.24L367.965 362.509Z",
    fill: "#4E505D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.37 371.148L410.204 371.754C410.76 371.823 411.27 371.428 411.339 370.871C411.409 370.313 411.012 369.805 410.456 369.734L405.622 369.13C405.064 369.06 404.557 369.455 404.486 370.012C404.417 370.569 404.812 371.079 405.37 371.148Z",
    fill: "#34353D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.873 369.559C400.804 370.116 401.199 370.626 401.756 370.695C402.314 370.765 402.822 370.368 402.893 369.811C402.961 369.253 402.567 368.746 402.01 368.677C401.452 368.606 400.944 369.002 400.873 369.559Z",
    fill: "#34353D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.447 369.131C397.378 369.689 397.773 370.197 398.33 370.268C398.888 370.336 399.396 369.941 399.467 369.383C399.535 368.826 399.142 368.319 398.584 368.248C398.026 368.179 397.518 368.574 397.447 369.131Z",
    fill: "#34353D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.746 136.194L398.516 194.925C399.188 203.187 392.899 210.37 384.62 210.797C376.513 211.214 369.6 204.979 369.184 196.871L368.743 188.281C356.424 188.915 346.065 179.155 345.965 166.823L345.732 138.666L393.746 136.194Z",
    fill: "#EE8D6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.581 154.353C375.081 154.021 375.832 159.64 373.329 159.972C370.829 160.303 370.078 154.686 372.581 154.353Z",
    fill: "#47241E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.289 155.416C359.788 155.084 360.539 160.702 358.035 161.035C355.535 161.367 354.785 155.749 357.289 155.416Z",
    fill: "#47241E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.361 149.467C369.598 149.613 369.415 150.404 369.407 151.015C369.404 151.248 369.405 151.496 369.563 151.685C369.838 152.019 370.445 152.035 370.969 152.017C373.832 151.921 379.473 152.359 379.815 151.61C379.819 149.331 370.539 149.433 370.361 149.467Z",
    fill: "#59393B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.855 150.132C359.611 150.236 359.743 151.019 359.714 151.63C359.702 151.862 359.685 152.11 359.515 152.309C359.218 152.658 358.608 152.709 358.086 152.721C355.225 152.788 349.545 153.546 349.25 152.816C349.39 150.532 358.68 150.108 358.855 150.132Z",
    fill: "#59393B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.853 167.61C364.67 167.771 363.563 167.758 362.417 167.577C363.612 164.548 364.214 161.41 364.151 158.131C364.134 157.279 362.816 157.346 362.83 158.196C362.894 161.539 362.271 164.718 360.939 167.783C360.771 168.17 360.941 168.636 361.38 168.733C362.914 169.073 364.356 169.143 365.918 168.929C366.755 168.815 366.698 167.495 365.853 167.61Z",
    fill: "#D48F5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.733 153.26L346.22 169.954C346.22 169.954 355.361 165.919 364.699 165.473C374.037 165.029 383.476 173.504 383.476 173.504C383.476 173.504 390.673 167.253 388.58 150.799H394.939C394.939 150.799 403.921 187.484 376.705 188.737C370.889 189.005 353.805 189.164 349.203 187.32C339.632 183.485 342.021 149.244 342.021 149.244L345.733 153.26Z",
    fill: "#744A4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.591 151.698C412.158 174.232 397.092 177.383 397.092 177.383L394.939 154.114C370.587 154.818 362.221 137.816 362.221 137.816C355.376 151.894 345.733 153.261 345.733 153.261C334.29 153.261 332.678 137.156 334.573 125.9C336.438 114.805 358.084 116.729 372.816 121.327C374.703 120.128 378.741 115.661 390.934 115.595C402.44 115.529 408.866 145.333 409.591 151.698Z",
    fill: "#744A4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.939 154.114C394.939 154.114 402.266 151.327 403.702 155.832C405.139 160.337 399.16 163.547 395.963 163.465L394.939 154.114Z",
    fill: "#EE8D6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.712 421.752L313.73 368.284C297.468 373.197 287.4 389.436 290.234 406.184L316.279 541.814L337.683 537.814L323.589 420.16L371.712 421.752Z",
    fill: "#92A9B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.575 387.508L320.123 392.817C310.938 396.192 305.441 405.606 307.013 415.264L327.299 539.756",
    stroke: "#ABC5D2",
    strokeWidth: 0.333333,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.211 581.184L342.665 569.311L342.164 565.178L338.671 536.169L314.829 540.474C314.829 540.474 316.971 559.071 297.668 561.266C283.28 562.902 281.292 571.468 281.507 576.807C281.607 579.368 282.211 581.184 282.211 581.184Z",
    fill: "#3B1C05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.852 537.22L335.178 567.963",
    stroke: "#94460D",
    strokeWidth: 0.333333,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.282 556.121C334.282 556.121 317.356 555.43 320.839 571.08",
    stroke: "#94460D",
    strokeWidth: 0.333333,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.21 581.184L342.664 569.311L342.163 565.178L281.506 576.807C281.606 579.368 282.21 581.184 282.21 581.184Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.806 423.396C382.629 423.396 384.107 421.92 384.107 420.095V384.364C384.107 373.808 392.694 365.222 403.249 365.222H473.66C475.485 365.222 476.962 363.743 476.962 361.92C476.962 360.097 475.485 358.619 473.66 358.619H403.249C389.055 358.619 377.504 370.169 377.504 384.364V420.095C377.504 421.92 378.982 423.396 380.806 423.396Z",
    fill: "#E5EDF0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg);
export default __webpack_public_path__ + "static/media/Img.15d89c5f3aad57023e80003bce301cdc.svg";
export { ForwardRef as ReactComponent };